import './bootstrap';

// Externals
import '@wwdev/bootstrap/index.js';
import '@wwdev/functions/index.js';
import './wwdev/cookiebar/index';
import './wwdev/forms/index';
import '@fancyapps/fancybox';
$.fancybox.defaults.backFocus = false;
// import './wwdev/webshop/index.js';
// import '@wwdev/myaccount/index.js';
// import '@wwdev/register';
// import '@wwdev/search';
import '@wwdev/contentable';
import '@wwdev/shared';
// import '@wwdev/functions/setEqualHeightsPerRow';

import './base/dynamic-height/index.js';
import './base/EqualHeights.js';
import './base/utils.js';

import './externals/hamburgers.js';
import './externals/animate.js';
import './externals/swiper/index.js';
import './externals/lottie.js';

import './sections/UspSlider.js';
import './sections/PaneGroup.js';
import './sections/CasusUitgelicht.js';
import './sections/TitleNumberCards.js';
import './sections/AnimatedScroll.js';
